import { createAvatar as _createAvatar } from "@dicebear/avatars";
import * as botStyles from "@dicebear/avatars-bottts-sprites";

const createBotAvatar = (options = {}) => {
  const avatar = _createAvatar(botStyles, options);
  return avatar;
};

export { createBotAvatar };
